export default "__VITE_ASSET__cYLvS3sm__"